import React, { useContext, useEffect, Fragment } from 'react'
import { useLazyQuery } from '@apollo/client'
import AutocompleteComponent from '../../../components/filters/AutocompleteComponent'
import { GET_CLIENTS } from '../../../queries/factory'
import { FactoryFiltersContext } from '../../../context/FactoryFiltersContext'

export default function Clients (): JSX.Element {
  const { filters, setFilters } = useContext(FactoryFiltersContext)
  const [getData, { data }] = useLazyQuery(
    GET_CLIENTS, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { filters }
    })
  }, [filters])

  const onChange = (value: any) => {
    setFilters({
      clients: value
    })
  }

  const clients: Array<string> = []

  data?.aggregation?.aggregations?.clients?.buckets.map((client: any) => {
    clients.push(client.key)
  })

  const typographLabel = 'Clients'

  return (
    <Fragment>
      <AutocompleteComponent
        labelValue={typographLabel}
        data={clients}
        defaultValues={filters?.clients}
        onChange={onChange}
      />
    </Fragment>
  )
}
